import React, {FunctionComponent, useEffect} from 'react';
import {DemoRequest, DemoRequestProps} from './demoRequest.component';
import {KlDialogTitle, KlResponsiveDialog} from "@klear/web-components";

const styles = require('./demoRequestDialog.component.scss');

interface DemoRequestDialogProps extends DemoRequestProps {
    open: boolean;
    onClose: () => void;
}

//TODO Alex - use custom hook later
declare const analytics: {
    track: (eventName: string, params?: Record<string, string | boolean | null>) => Promise<void>;
};

export const DemoRequestDialog: FunctionComponent<DemoRequestDialogProps> = props => {
    const {open, onClose, ...demoProps} = props;

    useEffect(() => {
        if(open && typeof analytics !== 'undefined'){
            analytics.track(`Demo Request Opened`, {
                category: 'Demo Request',
                label: document.title
            });
        }
    },[open]);

    return (
        <KlResponsiveDialog open={open} onClose={onClose} maxWidth={false} scroll={'body'} keepMounted={true}
                classes={{paper: styles.demoRequestDialog, container: styles.demoRequestDialogContainer}}>
            <KlDialogTitle onCancel={onClose} fullScreenOnly cancelText={'Close'} fixedCancel hideTitleBorder
                           customBackgroundClass={styles.demoRequestDialogTitle} />
            <DemoRequest {...demoProps} isDialog/>
        </KlResponsiveDialog>
    );
};